module.exports = __webpack_public_path__ + "static/media/RightSpeaker.dfb6d9a5.svg";